document.addEventListener('DOMContentLoaded', function () {

  const triggers = document.querySelectorAll('.video-trigger');
  const popup = document.getElementById('video-popup');
  const popupVideo = document.getElementById('popup-video');
  const closePopup = document.querySelector('.close-popup');

  triggers.forEach(trigger => {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      const videoUrl = this.getAttribute('data-video-url');
      popup.querySelector('source').setAttribute('src', videoUrl);
      popupVideo.load();
      popup.classList.add('visible');
      popup.classList.remove('hidden');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    });
  });

  closePopup.addEventListener('click', function () {
    popup.classList.remove('visible');
    popup.classList.add('hidden');
    document.documentElement.style.overflow = 'initial';
    document.body.style.overflow = 'initial';
    popupVideo.pause();
  });

  popup.addEventListener('click', function (event) {
    if (event.target === popup) {
      popup.classList.remove('visible');
      popup.classList.add('hidden');
      document.documentElement.style.overflow = 'initial';
      document.body.style.overflow = 'initial';
      popupVideo.pause();
    }
  });
});